import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import TablyPage from './pages/TablyPage';
import AvisoDePrivacidadPage from './pages/AvisoDePrivacidadPage';
import './styles/global.scss';

function App() {
  return (
    <div className="app-container">
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tably" element={<TablyPage />} />
            <Route path="/aviso-de-privacidad" element={<AvisoDePrivacidadPage />} />
          </Routes>
        </Layout>
      </Router>
    </div>
  );
}

export default App;
